import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name cigarette-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8bGluZSB4MT0iMiIgeDI9IjIyIiB5MT0iMiIgeTI9IjIyIiAvPgogIDxwYXRoIGQ9Ik0xMiAxMkgydjRoMTQiIC8+CiAgPHBhdGggZD0iTTIyIDEydjQiIC8+CiAgPHBhdGggZD0iTTE4IDEyaC0uNSIgLz4KICA8cGF0aCBkPSJNNyAxMnY0IiAvPgogIDxwYXRoIGQ9Ik0xOCA4YzAtMi41LTItMi41LTItNSIgLz4KICA8cGF0aCBkPSJNMjIgOGMwLTIuNS0yLTIuNS0yLTUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/cigarette-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CigaretteOff: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '2', x2: '22', y1: '2', y2: '22' }],
    ['path', { d: 'M12 12H2v4h14' }],
    ['path', { d: 'M22 12v4' }],
    ['path', { d: 'M18 12h-.5' }],
    ['path', { d: 'M7 12v4' }],
    ['path', { d: 'M18 8c0-2.5-2-2.5-2-5' }],
    ['path', { d: 'M22 8c0-2.5-2-2.5-2-5' }],
  ],
];

export default CigaretteOff;
